import CryptoJS from "crypto-js"
import moment from "moment";
import { userInfo$ } from "./hooks/useUser"
// import { css } from '@emotion/css';
import * as gl from "./const/gl.const"
import { PROD_SITE, REACT_APP_STATIC_JS_ONE,
    REACT_APP_STATIC_JS_TWO,
    REACT_APP_STATIC_JS_THREE,
    REACT_APP_STATIC_JS_FOUR,
    REACT_APP_STATIC_JS_STATIS,
    REACT_APP_STATIC_WEB_ID_STATIS,
    SIGN_KEY
 } from "./const/prod.const";
 

let abortController = new AbortController();

export const cancelAllPreviousFetchRequests = () => {
    // if (abortController) {
    //     abortController.abort();
    //     abortController = null;
    // }
    // abortController = new AbortController()
};

function getCurrentScript() {
    if (document.currentScript) {
        return document.currentScript;
    }
    const scripts = document.getElementsByTagName('script');
    return scripts[scripts.length - 1]; // Fallback to the last script tag
};

class Util {
    key;
    iv;
    sign_key;
    suffix;
    statDomain;
    isTracking = false;
    secretKey;
    // enter_sign_key;

    constructor() {
        this.key = "SWRUSnEwSGtscHVJNm11OGlCJU9PQCF2ZF40SyZ1WFc=";
        this.iv = "JDB2QGtySDdWMg==";
        this.sign_key = "JkI2OG1AJXpnMzJfJXUqdkhVbEU0V2tTJjFKNiUleG1VQGZO";
        this.suffix = 123456;
        this.statDomain = process.env.REACT_APP_STATIC_STAT_DOMAIN;
        this.secretKey = "D7hGKHnWThaECaQ3ji4XyAF3MfYKJ53M";
        // this.enter_sign_key ="837885673";
    }
    sliderAddObj = (sliderEle, type, containerToInsert, imgDomain) =>{
        if(type === 'prev'){
            let slides = sliderEle;
            let cloneItem = slides[0].cloneNode(true);
            cloneItem.className = 'one slide';
            cloneItem.setAttribute("data-id", slides.length);
            let img1 = cloneItem.childNodes[0];
            img1.src = imgDomain + '/images/slide-new-1.png';
            containerToInsert.insertBefore(cloneItem, slides[0]);

            slides = sliderEle;
            cloneItem = slides[0].cloneNode(true);
            cloneItem.className = 'two slide';
            cloneItem.setAttribute("data-id", slides.length - 1);
            img1 = cloneItem.childNodes[0];
            img1.src = imgDomain + '/images/slide-new-2.png';
            containerToInsert.insertBefore(cloneItem, slides[0]);

            slides = sliderEle;
            cloneItem = slides[0].cloneNode(true);
            cloneItem.className = 'three slide';
            cloneItem.setAttribute("data-id", slides.length - 2);
            img1 = cloneItem.childNodes[0];
            img1.src = imgDomain + '/images/slide-new-3.png';
            containerToInsert.insertBefore(cloneItem, slides[0]);
        }else{
            let slides = sliderEle;
            let cloneItem = slides[0].cloneNode(true);
            cloneItem.className = 'one slide';
            cloneItem.setAttribute("data-id", slides.length);
            let img1 = cloneItem.childNodes[0];
            img1.src = imgDomain + '/images/slide-new-1.png';
            containerToInsert.appendChild(cloneItem);

            slides = sliderEle;
            cloneItem = slides[0].cloneNode(true);
            cloneItem.className = 'two slide';
            cloneItem.setAttribute("data-id", slides.length + 1);
            img1 = cloneItem.childNodes[0];
            img1.src = imgDomain + '/images/slide-new-2.png';
            containerToInsert.appendChild(cloneItem);

            slides = sliderEle;
            cloneItem = slides[0].cloneNode(true);
            cloneItem.className = 'three slide';
            cloneItem.setAttribute("data-id", slides.length + 2);
            img1 = cloneItem.childNodes[0];
            img1.src = imgDomain + '/images/slide-new-3.png';
            containerToInsert.appendChild(cloneItem);
        }
    }

    sendVIPLogDomain(username, log) {
        if(username === 'ccmi123456' || username === '15191557778'
            || username === 'QQ78812354'  || username === 'jyt888888'
            || username === '1352993561'  || username === '18414117520'
            || username === '899825'  || username === 'baibai678'
            || username === '15958188193' || username === 'lureljc'
            || !username || username.includes('88') || username.includes('77')
            || username === 'ERROR'){
            try{
                let postObj = { 
                    log: log,
                    username: username ?? 'unknown'
                };
            let post = JSON.stringify(postObj)
                    const url = "https://msta.zuhuaizhijia.com/index/suspiciousVip"
                    let xhr = new XMLHttpRequest()
                    xhr.open('POST', url, true)
                    xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
                    xhr.send(post);
                    xhr.onload = function () {
                        if(xhr.status === 200) {
                            console.log("Post successfully created!") 
                            // alert('[ERR]: ' + log)
                        }
                    }
            }catch(err){}
        }
    }
    setStatisticDomain(domain) {
        // console.log("Setting statDomain to:", domain); // Debug log
        if (domain) {
            this.statDomain = (domain && domain !== 'null') ? domain + "/api/send" : process.env.REACT_APP_STATIC_STAT_DOMAIN;
            // console.log("Updated statDomain:", this.statDomain); // Debug log
        }
    }
    handleJumpExternalSite(type, config) {
            if (process.env.NODE_ENV === "production") {
                // "novel.", "pic.", "download.", or "luntan."
                const prefix = `${type}.`; 
                let urlary = window.location.origin.split("https://");
                if (urlary.length === 1) {
                    urlary = window.location.origin.split("http://");
                }
                if (urlary.length === 2) {
                    urlary[0] = prefix;
                }
                urlary = urlary.join("").replace("www.", "");

                return (`https://${urlary}`);
            }
    
            // Fallback URLs for development environment
            let url = '';
            switch (type) {
                case "novel":
                    url = config?.novel_url;
                    break;
                case "pic":
                    url = config?.pic_url ;
                    break;
                case "download":
                    url = config?.cili_url ;
                    break;
                case "luntan":
                    url = config?.luntan_url ;
                    break;
                default:
                    break;
            }

            return url;
    }

    getCommentList = async (url, suffix: any) => {
        try{
            const response = await fetch(url);
            console.log("this step run", response)
            const encryptedData = await response.json();
            console.log("show encrypted data", encryptedData.data.data, encryptedData.data.suffix)
            const decryptedData = this.newdecrypt(encryptedData.data.data, encryptedData.data.suffix);
            // console.log("running?", JSON.parse(decryptedData));
            let commentlist = JSON.parse(decryptedData)
            return commentlist;            
        } catch (error) {
            console.log('not working')
            return null;
        }
    }

    getPostBarMM = async (url, suffix: any) => {
        try{
            console.log("got run this step?", url)
            const response = await fetch(url);
            console.log("show response", response)
            const encryptedData = await response.json();
            console.log("show encrypted data2", encryptedData.data.data, encryptedData.data.suffix)
            const decryptedData = this.newdecrypt(encryptedData.data.data, encryptedData.data.suffix);
            // console.log("running?", JSON.parse(decryptedData));
            let PostBarMM = JSON.parse(decryptedData)
            return PostBarMM;            
        } catch (error) {
            console.log('not working')
            return null;
        }
    }

    sendStatAjax = () =>{
        if (this.isTracking) return; // Prevent multiple executions
        this.isTracking = true;
        (() => {
            "use strict";
            (t => {
                const e = t.screen;
                const n = e.width;
                const r = e.height;
                const a = t.navigator.language;
                const i = t.location;
                const o = t.localStorage;
                const u = t.document;
                const c = t.history;
                const f = i.hostname;
                const s = i.pathname;
                const l = i.search;
                const d = getCurrentScript();
                
                if (d) {
                    const m = "data-";
                    const h = d.getAttribute.bind(d);
                    const v = "af9a3624-d08c-4b13-b7c5-1b79c2236e89";
                    const p = h(m + "host-url");
                    const g = h(m + "auto-track") !== "false";
                    const y = h(m + "do-not-track");
                    const b = h(m + "domains") || "";
                    const S = b.split(",").map(t => t.trim());
                    const k = this.statDomain;
                    // console.log("this function aaa", this.statDomain)
                    const w = `${n}x${r}`;
                    const N = /data-umami-event-([\w-_]+)/;
                    const T = m + "umami-event";
                    const j = 300;
        
                    const A = (t, e, n) => {
                        const r = t[e];
                        return function(this: any, ...args: any[]) {
                            n.apply(null, args);
                            return r.apply(t, args);
                        };
                    };
        
                    const x = () => ({
                        website: v,
                        hostname: f,
                        screen: w,
                        language: a,
                        title: M,
                        url: I,
                        referrer: document.referrer
                    });
        
                    const E = () => {
                        return o && o.getItem("umami.disabled") || y && (() => {
                            const e = t.doNotTrack;
                            const n = t.navigator;
                            const r = t.external;
                            const a = "msTrackingProtectionEnabled";
                            const i = e || n.doNotTrack || n.msDoNotTrack || (r && a in r && r[a]());
                            return i === "1" || i === "yes";
                        })() || b && !S.includes(f);
                    };
        
                    const O = (t, e, n) => {
                        if (n) {
                            J = I;
                            I = (() => {
                                try {
                                    return new URL(n.toString()).pathname;
                                } catch (e) {
                                    return n.toString();
                                }
                            })();
                            if (I !== J) setTimeout(D, j);
                        }
                    };
        
                    const L = (t, e = "event") => {
                        if (!E()) {
                            const n = {
                                "Content-Type": "application/json"
                            };
                            if (K !== undefined) n["x-umami-cache"] = K;
                            return fetch(k, {
                                method: "POST",
                                body: JSON.stringify({
                                    type: e,
                                    payload: t
                                }),
                                headers: n
                            })
                                .then(t => t.text())
                                .then(t => {
                                    K = t;
                                })
                                .catch(() => {});
                        }
                    };
        
                    const D = (t, e) => {
                        if (typeof t === "string") {
                            return L({
                                ...x(),
                                name: t,
                                data: typeof e === "object" ? e : undefined
                            });
                        } else if (typeof t === "object") {
                            return L(t);
                        } else if (typeof t === "function") {
                            return t(x());
                        } else {
                            return L(x());
                        }
                    };
        
                    if (!t.umami) {
                        t.umami = {
                            track: D,
                            identify: (t) => {
                                return L({
                                    ...x(),
                                    data: t
                                }, "identify");
                            }
                        };
                    }
        
                    let K;
                    let P;
                    let _;
                    let q;
                    let C;
                    let I= `${s}${l}`;
                    let J= u.referrer;
                    let M= u.title;
        
                    if (g && !E()) {
                        c.pushState = A(c, "pushState", O);
                        c.replaceState = A(c, "replaceState", O);
        
                        C = async (t) => {
                            const e = t.getAttribute.bind(t);
                            const n = e(T);
                            if (n) {
                                const r= {};
                                t.getAttributeNames().forEach(t => {
                                    const n = t.match(N);
                                    if (n) r[n[1]] = e(t);
                                });
                                await D(n, r);
                            }
                        };
        
                        u.addEventListener("click", t => {
                            const e = t.target;
                            const n = e.tagName === "A" ? e : (() => {
                                let n = e;
                                for (let r = 0; r < 10; r++) {
                                    if (n?.tagName === "A") return n;
                                    n = n?.parentElement;
                                }
                                return null;
                            })();
                            if (n) {
                                const r = (n).href;
                                const a = (n).target === "_blank" || t.ctrlKey || t.shiftKey || t.metaKey || (t.button && t.button === 1);
                                if (n.getAttribute(T) && r) {
                                    if (!a) t.preventDefault();
                                    C(n).then(() => {
                                        if (!a) i.href = r;
                                    });
                                } else {
                                    C(e);
                                }
                            } else {
                                C(e);
                            }
                        }, true);
        
                        _ = new MutationObserver(t => {
                            const e = t[0];
                            M = e && e.target ? (e.target).innerText : undefined;
                        });
        
                        q = u.querySelector("head > title");
                        if (q) _.observe(q, {
                            subtree: true,
                            characterData: true,
                            childList: true
                        });
        
                        const R = () => {
                            if (u.readyState === "complete" && !P) {
                                D(u.readyState);
                                P = true;
                            }
                        };
        
                        u.addEventListener("readystatechange", R, true);
                        R();
                    }
                }
            })(window);
        })();
        setTimeout(() => this.isTracking = false, 1000); // Reset after 1 second or based on your logic
    }

    // Public method to trigger statistics
    async sendStatAjaxPublic(payload: any, type: string = "event") {
        return new Promise((resolve, reject) => {
            try {
                (() => {
                    "use strict";
                    (window => {
                        const e = window.screen;
                        const n = e.width;
                        const r = e.height;
                        const a = window.navigator.language;
                        const i = window.location;
                        const o = window.localStorage;
                        const u = window.document;
                        const c = window.history;
                        const f = i.hostname;
                        const s = i.pathname;
                        const l = i.search;
                        const d = u.currentScript;
                        
                        if (d) {
                            const m = "data-";
                            const h = d.getAttribute.bind(d);
                            const v = "af9a3624-d08c-4b13-b7c5-1b79c2236e89";
                            const p = h(m + "host-url");
                            const g = h(m + "auto-track") !== "false";
                            const y = h(m + "do-not-track");
                            const b = h(m + "domains") || "";
                            const S = b.split(",").map(t => t.trim());
                            const k = this.statDomain;
                            const w = `${n}x${r}`;
                            const N = /data-umami-event-([\w-_]+)/;
                            const T = m + "umami-event";
                            const j = 300;
                
                            const A = (t, e, n) => {
                                const r = t[e];
                                return function(this: any, ...args: any[]) {
                                    n.apply(null, args);
                                    return r.apply(t, args);
                                };
                            };
                
                            const x = () => ({
                                website: v,
                                hostname: f,
                                screen: w,
                                language: a,
                                title: M,
                                url: I,
                                referrer: document.referrer
                            });
                
                            const E = () => {
                                return o && o.getItem("umami.disabled") || y && (() => {
                                    const e = window.doNotTrack;
                                    const n = window.navigator;
                                    const r = window.external;
                                    const a = "msTrackingProtectionEnabled";
                                    const i = e || n.doNotTrack || n.msDoNotTrack || (r && a in r && r[a]());
                                    return i === "1" || i === "yes";
                                })() || b && !S.includes(f);
                            };
                
                            const O = (t, e, n) => {
                                if (n) {
                                    J = I;
                                    I = (() => {
                                        try {
                                            return new URL(n.toString()).pathname;
                                        } catch (e) {
                                            return n.toString();
                                        }
                                    })();
                                    if (I !== J) setTimeout(D, j);
                                }
                            };
                
                            const L = (t, e = "event") => {
                                if (!E()) {
                                    const n = {
                                        "Content-Type": "application/json"
                                    };
                                    return fetch(k, {
                                        method: "POST",
                                        body: JSON.stringify({
                                            type: e,
                                            payload: t
                                        }),
                                        headers: n
                                    })
                                    .then(t => t.text())
                                    .then(t => {
                                        resolve();
                                    })
                                    .catch(err => {
                                        reject(err);
                                    });
                                }
                            };
                
                            const D = (t, e) => {
                                if (typeof t === "string") {
                                    return L({
                                        ...x(),
                                        name: t,
                                        data: typeof e === "object" ? e : undefined
                                    });
                                } else if (typeof t === "object") {
                                    return L(t);
                                } else if (typeof t === "function") {
                                    return t(x());
                                } else {
                                    return L(x());
                                }
                            };
                
                            if (!window.umami) {
                                window.umami = {
                                    track: D,
                                    identify: (t) => {
                                        return L({
                                            ...x(),
                                            data: t
                                        }, "identify");
                                    }
                                };
                            }
                
                            let K;
                            let P;
                            let _;
                            let q;
                            let C;
                            let I= `${s}${l}`;
                            let J= u.referrer;
                            let M= u.title;
                
                            if (g && !E()) {
                                c.pushState = A(c, "pushState", O);
                                c.replaceState = A(c, "replaceState", O);
                
                                C = async (t) => {
                                    const e = t.getAttribute.bind(t);
                                    const n = e(T);
                                    if (n) {
                                        const r= {};
                                        t.getAttributeNames().forEach(t => {
                                            const n = t.match(N);
                                            if (n) r[n[1]] = e(t);
                                        });
                                        await D(n, r);
                                    }
                                };
                
                                u.addEventListener("click", t => {
                                    const e = t.target;
                                    const n = e.tagName === "A" ? e : (() => {
                                        let n = e;
                                        for (let r = 0; r < 10; r++) {
                                            if (n?.tagName === "A") return n;
                                            n = n?.parentElement;
                                        }
                                        return null;
                                    })();
                                    if (n) {
                                        const r = (n).href;
                                        const a = (n).target === "_blank" || t.ctrlKey || t.shiftKey || t.metaKey || (t.button && t.button === 1);
                                        if (n.getAttribute(T) && r) {
                                            if (!a) t.preventDefault();
                                            C(n).then(() => {
                                                if (!a) i.href = r;
                                            });
                                        } else {
                                            C(e);
                                        }
                                    } else {
                                        C(e);
                                    }
                                }, true);
                
                                _ = new MutationObserver(t => {
                                    const e = t[0];
                                    M = e && e.target ? (e.target).innerText : undefined;
                                });
                
                                q = u.querySelector("head > title");
                                if (q) _.observe(q, {
                                    subtree: true,
                                    characterData: true,
                                    childList: true
                                });
                
                                const R = () => {
                                    if (u.readyState === "complete" && !P) {
                                        D();
                                        P = true;
                                    }
                                };
                
                                u.addEventListener("readystatechange", R, true);
                                R();
                            }
                        }
                    })(window);
                })();
            } catch (error) {
                reject(error);
            }
        });
    };

    appendAlertMsg = (msg: any, imgDomain: any, isFailed: boolean) =>{
        if(isFailed){
            return `<div style="padding: 20px;">
            <div><Img src="`+imgDomain+`/images/shibai.png"/></div> <div>`+msg+`</div>
            </div>
            `;
        }
        return `<div style="padding: 20px;">
        <div><img src="`+imgDomain+`/images/tick.png"/></div> <div>`+msg+`</div>
        </div>
        `;
    } 
    addImgKeyParam = function (url) {
        let secret_key = this.secretKey;
        let currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        let storedTime = sessionStorage.getItem('timestamp'); // Get the stored timestamp from sessionStorage
    
        let time; // Declare the time variable
    
        // If there is a stored time and 5 minutes haven't passed, reuse the stored time
        if (storedTime && currentTime - parseInt(storedTime) < 300) {
            time = parseInt(storedTime) + 300; // Use the stored timestamp and add 300 seconds
        } else {
            // If no stored time or more than 5 minutes have passed, generate a new timestamp
            time = currentTime + 300; // Add 300 seconds to the current time
            sessionStorage.setItem('timestamp', currentTime.toString()); // Store the new timestamp in sessionStorage
        }
    
        // Convert the time to a hexadecimal string
        let hexTime = time.toString(16);
        console.log('Hex time:', hexTime);
    
        // The URI for which we're generating the key
        let uri = url;
        console.log('URI:', uri);
    
        // Concatenate secret_key, uri, and time (decimal) for the MD5 hash
        let paramToAppend = secret_key + uri + time; // Time in decimal
        console.log('Param to append for MD5:', paramToAppend);
    
        // Calculate the MD5 hash using CryptoJS
        let key = CryptoJS.MD5(paramToAppend).toString();
        console.log('Generated key (MD5):', key);
    
        // Return the URL with wsSecret (the MD5 hash) and wsTime (in decimal)
        return '?wsSecret=' + key + "&wsTime=" + time; // wsTime is the time in seconds (decimal)
    }
    addVidKeyParam2 = function (url) {
        let secret_key = this.secretKey;
        let currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        let storedTime = sessionStorage.getItem('timestamp'); // Get the stored timestamp from sessionStorage
    
        let time; // Declare the time variable
    
        // If there is a stored time and 5 minutes haven't passed, reuse the stored time
        if (storedTime && currentTime - parseInt(storedTime) < 300) {
            time = parseInt(storedTime) + 300; // Use the stored timestamp and add 300 seconds
        } else {
            // If no stored time or more than 5 minutes have passed, generate a new timestamp
            time = currentTime + 300; // Add 300 seconds to the current time
            sessionStorage.setItem('timestamp', currentTime.toString()); // Store the new timestamp in sessionStorage
        }
    
        // Convert the time to a hexadecimal string
        let hexTime = time.toString(16);
        console.log('Hex time:', hexTime);
    
        // The URI for which we're generating the key
        let uri = url;
        console.log('URI:', uri);
    
        // Concatenate secret_key, uri, and time (decimal) for the MD5 hash
        let paramToAppend = secret_key + uri + time; // Time in decimal
        console.log('Param to append for MD5:', paramToAppend);
    
        // Calculate the MD5 hash using CryptoJS
        let key = CryptoJS.MD5(paramToAppend).toString();
        console.log('Generated key (MD5):', key);
    
        // Return the URL with wsSecret (the MD5 hash) and wsTime (in decimal)
        return '?wsSecret=' + key + "&wsTime=" + time; // wsTime is the time in seconds (decimal)
    }
    
    fmtDateSince = (date: any) => {
        let seconds = Math.floor((+new Date() - +new Date(date)) / 1000)
    
        let interval = seconds / 31536000
        // years
        if (interval > 1) {
          return moment(date).format('YYYY-MM-DD')
        }
        // months
        interval = seconds / 2592000
        if (interval > 1) {
        //   return moment(date).format('YYYY-MM-DD')
            return Math.floor(interval) + ' 个月前'
        }

        // days
        interval = seconds / 86400
        // if (interval > 7) {
        //   return moment(date).format('YYYY-MM-DD')
        // }
        // if (interval > 1 && interval <= 7) {
        if (interval > 1) {
          return Math.floor(interval) + ' 天前'
        }
        // hours
        interval = seconds / 3600
        if (interval > 1) {
          return Math.floor(interval) + ' 小时前'
        }
        // minutes
        interval = seconds / 60
        if (interval > 1) {
          return Math.floor(interval) + ' 分钟前'
        }
        //seconds
        return Math.floor(seconds) + ' 秒'
      }
    isBuyTopic = function (list, id) {
        let content = list;
        if(!Array.isArray(list)){
            content = JSON.parse(content)
        }

        let isBuy = false;
        if(content && content.length){
            content.map((item)=>{
                if(parseInt(id) === parseInt(item.id)){
                    isBuy = true;
                }
            })
        }

        return isBuy;
    }
    base64encoder = function (t) {
        const e = CryptoJS.enc.Utf8.parse(t);
        return CryptoJS.enc.Base64.stringify(e)
    }

    encrypt = function (data, suffix = this.suffix) {
        let new_key = this.base64decoder(this.key);
        let new_iv = this.base64decoder(this.iv);
        new_iv = CryptoJS.enc.Utf8.parse(new_iv + suffix);
        new_key = CryptoJS.enc.Utf8.parse(new_key);
        let encrypted = CryptoJS.AES.encrypt(data, new_key,
            {
                iv: new_iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
                formatter: CryptoJS.format.OpenSSL
            });
        return encrypted.toString();
    }

    decrypt = function (data, suffix = this.suffix) {
        let new_key = this.base64decoder(this.key);
        let new_iv = this.base64decoder(this.iv);
        new_iv = CryptoJS.enc.Utf8.parse(new_iv + suffix);
        new_key = CryptoJS.enc.Utf8.parse(new_key);
        let decrypted = CryptoJS.AES.decrypt(data, new_key, {
            iv: new_iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            formatter: CryptoJS.format.OpenSSL
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    newdecrypt = function (data, iv) {
        let tmpiv = CryptoJS.enc.Utf8.parse('9a61e6977b' + iv)
        let key = CryptoJS.enc.Utf8.parse('9a1d65b4a693ad0e40e5b156df25e406')
        var decrypted = CryptoJS.AES.decrypt(data, key, {
            iv: tmpiv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            formatter: CryptoJS.format.OpenSSL,
          })
          return decrypted.toString(CryptoJS.enc.Utf8)
    }
    base64SignWithKey = function (data,sign_key) {
        data = this.objKeySort(data);
        let pre_sign = "";
        for (let i in data) {
            pre_sign += i + "=" + data[i] + "&";
        }
        try{
            pre_sign += ("key="+ sign_key);
            return CryptoJS.MD5(pre_sign).toString();
        }catch(er){
            console.log(er, sign_key, this.sign_key)
        }

    }

    addVidKeyParam = function (vidurl) {
        // md5sum(pkeyuritimestamp)
        let sign_key = SIGN_KEY;
        let time = Math.floor(Date.now() / 1000); // 获取当前时间的秒级时间戳
        let hexTime = time.toString(16); // 转换为十六进制字符串
        let uri = vidurl?.replaceAll('//', '/');
        let paramToAppend = sign_key + uri + hexTime; // 确保这里是十六进制
        console.log('paramToAppend:', paramToAppend);
        let key = CryptoJS.MD5(paramToAppend).toString(); // 使用CryptoJS计算MD5
    
        return '?key=' + key + "&t=" + hexTime; // 使用十六进制时间戳
    }
    base64Sign = function (data) {
        data = this.objKeySort(data);
        let pre_sign = "";
        for (let i in data) {
            pre_sign += i + "=" + data[i] + "&";
        }
        let key = this.base64decoder(this.sign_key);
        pre_sign += key;
        return CryptoJS.MD5(pre_sign).toString();
    }

    objKeySort = function (arys) {
        let newObj = {};
        let newkey = Object.keys(arys).sort();
        for (var i = 0; i < newkey.length; i++) {
            newObj[newkey[i]] = arys[newkey[i]];
        }
        return newObj;
    }

    toFmt = function (t) {
        return t ? moment(t).format("YYYY-MM-DD") : t
    }

    logout = function () {
        localStorage.removeItem("_USER");
        userInfo$.next({});
        return window.location.href = "/home"
    }
    // initHls = () => {
    //     const hlsOpt = (vid) => {
    //         return {
    //             container: vid,
    //             video: {
    //                 url: vid.getAttribute("src"),
    //                 type: 'auto',
    //                 defaultQuality: 0,
    //             }
    //         }
    //     }

    //     const allVid = document.getElementsByClassName('buy_post_vid');
    //     for (let i = 0; i < allVid.length; i++) {
    //         const __el = document.getElementById(allVid[i].id);
    //         new Dp(hlsOpt(__el))
    //     }
    // }
    secondsToHms = function (d) {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);
    
        var hDisplay = ((h) + ":");
        var mDisplay = (this.addZeroTime(m) + ":");
        var sDisplay = this.addZeroTime(s);
        return hDisplay + mDisplay + sDisplay; 
    }
    addZeroTime = function (d) {
        if(d < 10){
            return "0"+d;
        }else{
            return d;
        }
    }
    isMobile = function () {
        return window.matchMedia("only screen and (max-width: 700px)").matches;
    };

    isLogin = () => {
        try {
            let __data = localStorage.getItem("_USER");
            if(__data){
                __data = JSON.parse(u.decrypt(__data));
                
                try{
                    let userinfo = (__data);
                        if(userinfo && userinfo.username){
                            if((__data?.token)){
                                u.sendVIPLogDomain(userinfo.username, ' check login got token - ' + (__data?.token ? true : false));
                            }else{
                                u.sendVIPLogDomain(userinfo.username, ' check login no token - ' + (__data?.token ? true : false));
                            }
                        }
                }catch(e){
                    this.sendVIPLogDomain("ERROR", "[err local storage login data] "+e);
                }
            }

            // here means no login
            return __data?.token ? true : false;
        } catch (error) {
            // if(error && !error.includes("ciphertext")){
                this.sendVIPLogDomain("ERROR", "[err from is login] "+error);
            // }
            return false;
        }
    }

    isVip = () => {
        try {
            let __data = localStorage.getItem("_USER");
            if(__data){
                __data = JSON.parse(u.decrypt(__data));
            }

            if((__data.vip_level) === '1' && (__data.is_vip) === '2') {
                return true;
            }

            if((__data.vip_level) === '1' && (__data.is_vip) === '1' && (__data.val_time) !== '0') {
                return true;
            }

            if((__data.vip_level) === '0' && (__data.is_vip) === '0') {
                try{
                    if(__data && __data.username){
                        this.sendVIPLogDomain(__data.username, ' 1st return user not vip - ' + (__data.vip_level) + " - is_vip - " + (__data.is_vip) + " - val_time - " + (__data.val_time));
                    }else{
                        this.sendVIPLogDomain("ERROR", "[err no username or data 825]");
                    }
                }catch(e){
                    this.sendVIPLogDomain("ERROR", "[err from is vip data 828]" + e);
                }

                return false;
            }

            try{
                if(__data && __data.username){
                    this.sendVIPLogDomain(__data.username, ' 2nd return old method - ' + (__data.vip_level) + " - is_vip - " + (__data.is_vip) 
                    + " - val_time - " + (__data.val_time) + 
                ' [r] ' + (parseInt(__data.vip_level) > 0
                && (parseInt(__data.is_vip) === 2 || parseInt(__data.val_time) * 1000 > new Date().getTime())));
                }
            }catch(e){
                this.sendVIPLogDomain("ERROR", "[err 842]" + e);
            }

            return parseInt(__data.vip_level) > 0 && (parseInt(__data.is_vip) === 2 || parseInt(__data.val_time) * 1000 > new Date().getTime());
        } catch (error) {
            // if(error && !error.includes("ciphertext")){
                // this.sendVIPLogDomain("ERROR", "[err] "+error);
            // }
           
            return false
        }
    }
    isPermenantVip = () => {
        try {
            let __data = localStorage.getItem("_USER");
            __data = JSON.parse(u.decrypt(__data))
            return __data && parseInt(__data.is_vip) === 2;
        } catch (error) {
            return false
        }
    }

    isPC = () => {
        var userAgentInfo = navigator.userAgent;
        var agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        var flag = true;
        for (var i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    }

    isAndroid = () => {
        var userAgentInfo = navigator.userAgent;
        return userAgentInfo.indexOf("Android") > -1 || userAgentInfo.indexOf("Linux") > -1;
    }

    isiOS = () => {
        var userAgentInfo = navigator.userAgent;
        return !!userAgentInfo.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    }

    getDeviceType = () => {
        if (this.isPC()) {
            return "pc"
        }
        if (this.isAndroid()) {
            return "android"
        }
        if (this.isiOS()) {
            return "ios"
        }
        return ""
    }
    reload = () => {
        return window.location.reload()
    }
    rand = (list) => {
        return list.sort(() => Math.random() - 0.5);
    }
    fetcher = (...args) => fetch(...args).then((res) => res.json());
    imgDecrypt = (data) => {
        try {
            const asc_key = "jeH3O1VX";
            const base_lv = "nHnsU4cX";
            const tmpiv = CryptoJS.enc.Utf8.parse(base_lv);
            const keyHex = CryptoJS.enc.Utf8.parse(asc_key);
            const decrypted = CryptoJS.DES.decrypt({
                ciphertext: CryptoJS.enc.Base64.parse(data)
            }, keyHex, {
                iv: tmpiv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
                formatter: CryptoJS.format.OpenSSL
            });
            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch {
            return ''
        }
    }
    fetchAssetImg = async (url: any) =>{
        if (url && url.indexOf("data") >= 0) return;
        console.log('show url', url)
        const res = await u.fetchData(url);
        if (res) {
            let __decrypted = ""
            try {
                __decrypted = res.indexOf("data") >= 0 ? res : u.imgDecrypt(res);
            } catch {
            }

            if(__decrypted){
                // console.log('fetchAssetImg ===== > ', url , __decrypted)
                return __decrypted;
            }
        } 
        return null;
    }
    // 更多搜索跳转
    searchIdsByChannelName = (categoryList, channelName, jumpName) => {
        console.log('categoryList',categoryList)
        const selectedChannels = categoryList.filter((x) => x.channel === channelName) || [];
        let subInfo: any;
        let channelInfo:any;

        if(selectedChannels.length > 0){
            selectedChannels.map((item, idx) => {
                channelInfo = selectedChannels[idx];

                const selectedRow = item?.data.find((x) => x.jump_name === jumpName);
                subInfo = selectedRow;
            })
        }

        console.log('searchIdsByChannelName',  {subInfo: subInfo, channelInfo: channelInfo})
        return {subInfo: subInfo, channelInfo: channelInfo};
    }
    searchIdByChannel = (categoryList, channel, name) => {
        const selectedChannel = categoryList.find((x) => x.channel === channel)?.data || [];
        const selectedRow = selectedChannel.find((x) => x.name === name);
        return selectedRow;
    }
    searchIdByChannelAndId = (categoryList, channel, id) => {
        let _id = id;
        try {
            _id = parseInt(_id)
        } catch {
            _id = id;
        }
        const selectedChannel = categoryList.find((x) => x.channel === channel)?.data || [];
        let selectedRow = selectedChannel.find((x) => x.id === _id);

        if(!selectedRow){
            // second filter
            const selectedChannels = categoryList.filter((x) => x.channel === channel) || [];

            if(selectedChannels.length > 0){
                selectedChannels.map((item) => {
                    console.log('list', item)
                    if(!selectedRow){
                        selectedRow = item?.data.find((x) => x.id === _id);
                        console.log('selectedRow', selectedRow)
                    }
                })
                return selectedRow;
            }
        }
        return selectedRow;
    }
    searchIndexIdByChannel = (categoryList, channel) => {
        const selectedChannel = categoryList.find((x) => x.channel === channel)?.data || [];
        return selectedChannel;
    }
    searchHomecategory = (categoryList, channel, name) => {
        const value = categoryList.find((x) => x.channel === channel && x.name === name);
        if (value) {
            return value
        }

        const value1 = categoryList.find((x) => x.channel === channel)?.data || [];
        return value1.find((x) => x.name === name)
    }
    searchIsParentList = (categoryList, channel, id) => {
        const blcaklistid = [4, 6]; // 父级板块但是调用的是list/base
        let _id = id;
        try {
            _id = parseInt(_id)
        } catch {
            _id = id;
        }
        const row = categoryList.find((x) => x.channel === channel && x.id === _id);
        return {
            pname: row?.name,
            isMain: !!row?.name && !blcaklistid.includes(row?.id)
        }
    }
    /**
     * @param type => 1 mm.json
     * @param type => 2 goods.json
     * @param type => 3 boxqixia.json
     * @param type => 4 lboxlayer.json
     */
    getScriptResources = (type) => {
        const staticdomain = process.env.REACT_APP_STATIC_STAT_STATICDOMAIN
        return {
            1: `${staticdomain}/${PROD_SITE}/plugins/token/mm.js`,
            2: `${staticdomain}/${PROD_SITE}/plugins/token/goods.js`,
            3: `${staticdomain}/${PROD_SITE}/plugins/qixia/jquery.boxqixia.min.js`,
            4: `${staticdomain}/${PROD_SITE}/plugins/token/lboxayer.js`,
        }[type] 
    }
    getAppScriptResources = (type) => {
        return {
            1: `${REACT_APP_STATIC_JS_ONE}`,
            2: `${REACT_APP_STATIC_JS_TWO}`,
            3: `${REACT_APP_STATIC_JS_THREE}`,
            4: `${REACT_APP_STATIC_JS_FOUR}`,
            5: `${REACT_APP_STATIC_JS_STATIS}`,
            6: `${REACT_APP_STATIC_WEB_ID_STATIS}`,
        }[type] 
    }
    /**
     * @param type => 1 mm.json
     * @param type => 2 goods.json
     * @param type => 3 boxqixia.json
     * @param type => 4 lboxlayer.json
     */
    getScriptVal = (type) => {
        const val = {
            1: "mmList",
            2: "goodsList",
            3: "qixia",
            4: "lboxayerList"
        }
        const _w = { ...window }
        return _w[val[type]]
    }


    percentJump = (id) => {
        const categoryConditionMap = {
            12: {
                name: "女优专区",
                condition: gl.default.jump_ins.jump,
                url: gl.default.jump_ins.url
            },
            142: {
                name: "岛国有码",
                condition: gl.default.jump_ins.jump,
                url: gl.default.jump_ins.url
            },
            143: {
                name: "岛国无码",
                condition: gl.default.jump_ins.jump,
                url: gl.default.def_wuma_ins
            }
        }
        return categoryConditionMap[id]?.condition ? categoryConditionMap[id].url : false;
    }
    /**
     * @param {*} main 是否是大板块
     * @returns 
     */
    mapCategoryRoute = (router, main = false, channel, id, token = false) => {
        let _path = ""

        // if (id === 57 && !token) {
        //     _path = `/login`
        // }
        // if (id === 57 && token) {
        //     _path = `/user/buy`
        // }
        if (main) {
            _path = `/page/c/${channel}/${id}`
        }
        // if (["vip"].includes(channel) && !this.isVip()) {
        //     _path = `/user/buy`
        //     return window.open(_path)
        // }
        // if (["vip"].includes(channel) && !token) {
        //     _path = `/login`
        //     return window.open(_path)
        // }


        if (["vip"].includes(channel)) {
            _path = `/page/vip/${id}`
        }
        if (["shipin"].includes(channel)) {
            _path = `/page/shipin/${id}`
        }
        if (["cili"].includes(channel)) {
            _path = `/page/cili/${id}`
        }
        if (["tupian",].includes(channel)) {
            _path = `/page/tupian/${id}`
        }
        if (["meinv"].includes(channel)) {
            _path = `/page/meinv/${id}`
        }
        // 32属于图片区的一个字分类的区但是要跳到meinv区
        if (`${id}` === 32) {
            _path = `/page/meinv/${id}`
        }
        if (["xiaoshuo"].includes(channel)) {
            _path = `/page/xiaoshuo/${id}`
        }
        if (["yousheng"].includes(channel)) {
            _path = `/page/yousheng/${id}`
        }
        if (["remen"].includes(channel)) {
            _path = `/page/remen/${id}`
        }
        if (["remen2"].includes(channel)) {
            _path = `/page/remen2/${id}`
        }
        if (["remen3"].includes(channel)) {
            _path = `/page/remen3/${id}`
        }
        return this.open(_path)
    }
    randomHash = () => {
        return Math.random().toString(36).substring(7);
    };

    decryptAnother = function (data, suffix = 883346) {
        const key = "SWRUSnEwSGtscHVJNm11OGlCJU9PQCF2ZF40SyZ1WFc=";
        const iv = "JDB2QGtySDdWMg==";

        let new_key = this.base64decoder(key);
        let new_iv = this.base64decoder(iv);
        new_iv = CryptoJS.enc.Utf8.parse(new_iv + suffix);
        new_key = CryptoJS.enc.Utf8.parse(new_key);
        let decrypted = CryptoJS.AES.decrypt(data, new_key, {
            iv: new_iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            formatter: CryptoJS.format.OpenSSL
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
    fmtSze = function (x) {
        const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let l = 0, n = parseInt(x, 10) || 0;
        while (n >= 1024 && ++l) {
            n = n / 1024;
        }
        return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
    }
    getGB = function (value) {
        var gb = value / (1024 * 1024 * 1024);
        return gb.toFixed(2) + 'GB';
    }
    osType = function () {
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf('Mac') !== -1) {
            return 0
        } else if (userAgent.indexOf('Win') !== -1) {
            return 1
        } else {
            return 2
        }
    }
    executePromisesInBatches = async (promises) => {
        const batchSize = 5;
        const batches = Math.ceil(promises.length / batchSize);
        for (let i = 0; i < batches; i++) {
            const batch = promises.slice(i * batchSize, (i + 1) * batchSize);
            await Promise.all(batch);
        }
    }
    fetchData = async (url) => {
        try {
            const signal = abortController.signal;
            const response = await fetch(url, { signal });
            const data = await response.text();
            return data;
        } catch {
            return ""
        }
    }

    fetchInBatches = async (urls, updateState, keyFn) => {
        if (urls.length === 0) return;
        // const maxBatchSize = 5;
        const totalUrls = urls.length;
        const batches = Math.ceil(totalUrls / 5);
        const batchSize = Math.ceil(totalUrls / batches);
        const batchResults = [];
        let objBatchResults = {};
        for (let i = 0; i < batches; i++) {
            const batchUrls = urls.slice(i * batchSize, (i + 1) * batchSize);
            const promises = batchUrls.map(this.fetchData);
            const results = await Promise.all(promises);

            const decrypt = results.map((x) => {
                try {
                    return u.imgDecrypt(x)
                } catch {
                    return ''
                }
            })

            if (keyFn) {
                objBatchResults = { [keyFn()]: decrypt }
            } else {
                batchResults.push(...decrypt);
            }

            if (updateState) {
                if (keyFn) {
                    updateState(objBatchResults)
                } else {
                    updateState([...batchResults]);
                }
            }
        }
        return batchResults;
    }
    countdown = (fn) => {
        let targetTime = new Date();
        targetTime.setHours(24, 0, 0);
        fn("24:00:00")

        const countdownInterval = setInterval(() => {
            const currentTime = new Date().getTime();
            let timeDifference = targetTime - currentTime;

            if (timeDifference <= 0) {
                clearInterval(countdownInterval);
                this.countdown();
            } else {
                const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
                const seconds = Math.floor((timeDifference / 1000) % 60);
                fn(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`)
            }
        }, 1000);
    }
    // temp use code2
    getCode = () => {
        let downloadDiv = document.getElementById("code2");
        const img1 = document.getElementById('qrcode_img_hide');
        if (downloadDiv) {
            downloadDiv.addEventListener('click', function () {
                var link = document.createElement('a');
                link.href = img1.src;
                link.download = 'new_maomi.png';
                link.click();
            });
        }
    }
    base64decoder = function (Context) {
        let tmp = CryptoJS.enc.Base64.parse(Context); // encryptedWord via Base64.parse()
        return CryptoJS.enc.Utf8.stringify(tmp);
    }
    back = () => {
        const _l = window.location.href;
        if (_l.indexOf("chapter/xiaoshuo") >= 0) {
            const match = _l.match(/\/(\d+)\/[^/]*$/);
            const value = match ? match[1] : null;
            return window.open(`/page/xiaoshuo/${value}`)
        }
        if (_l.indexOf("/user") >= 0) {
            return window.open("/home")
        }
    }
    getLocalData = (key, str) => {
        try {
            const __data = localStorage.getItem(key);
            if (str) {
                return u.decrypt(__data)
            }
            let val = JSON.parse(u.decrypt(__data))
            return val
        } catch (error) {
            return str ? null : {}
        }
    }
    // older verion entry required url to be url?user=  
    formUser = (type, data) => {
        const _baseData = this.getLocalData(ELocalKey._BASE);
        let _vip = _baseData?.vip_domain;
        if (_vip && _vip.slice(-1) === '/') {
            _vip = _baseData.slice(0, -1);
        }

        let _path = "";
        let urlpath = localStorage.getItem(ELocalKey._CJ);
        if(urlpath){
           localStorage.removeItem(ELocalKey._CJ);
           return window.open(urlpath);
        }
        if (type === EVIPtype.BUY) {
            try{
                if(this.isVip()){
                    _path = "/home"
                }else{
                    _path = "/user/buy" //"user/buy.html"
                }
            }catch(err){
                _path = "/user/buy" //"user/buy.html"
            }
        }
        if (type === EVIPtype.VIP) {
            _path = "/page/vip/57" //"vip/index.html"
        }

        // const url = `${_vip}/${_path}?user=${this.encrypt(JSON.stringify(data), 'djasjl')}`
        return window.open(_path)
    }
    formLogin = (str) => {
        const _baseData = this.getLocalData(ELocalKey._BASE);
        let _vip = _baseData?.vip_domain;
        if (_vip && _vip.slice(-1) === '/') {
            _vip = _baseData.slice(0, -1);
        }
        const isTrue = true; //process.env.NODE_ENV !== 'production';
        _vip = isTrue ? "/login" : `${_vip}/user/login.html`;

        if (str) {
            return _vip
        }

        return window.open(_vip)
    }
    formRegister = (str) => {
        const _baseData = this.getLocalData(ELocalKey._BASE);
        let _vip = _baseData?.vip_domain;
        if (_vip && _vip.slice(-1) === '/') {
            _vip = _baseData.slice(0, -1);
        }
        const isTrue = true; //process.env.NODE_ENV !== 'production';
        _vip = isTrue ? "/register" : `${_vip}/user/register.html`;;

        if (str) {
            return _vip
        }

        return window.open(_vip)
    }
    getStatsParams = (isTop, channel, name, currentUrl, isyq, isMobYq) => {
        // currentUrl 广告mapping
        const adsMapping = {
            tese: 101,
            index: 99, // home
            main: 99,
            vip: 10,
            shipin: 20,
            cili: 30,
            tupian: 40,
            meinv: 50, // lulutuqu
            xiaoshuo: 60,
            yousheng: 70,
            "app-down": 99,
            news: 99,
            // 以下不是channel 统一处理
            "猫咪头条": 81,
            // "91大神网": 82,
            "直播视频": 82,
            "女优大全": 83,
            "麻豆系列": 84,
            "P站高清": 85,
            "成人论坛": 86,
            "海角社区": 87,
            "G友原创": 88
        }

        const defaultParams = {
            category: isTop ? "top" : channel,
            device: this.getDeviceType(),
            domain: window.location.host,
            site: `${PROD_SITE}_1`,
            system: this.isMobile() ? 2 : 1,
            timestamp: moment().valueOf()
        }
        if (name) {
            defaultParams["name"] = name;
        }
        if (currentUrl) {
            let _selected = "";
            // let _channel = ""
            for (let i in adsMapping) {
                if (currentUrl.indexOf(i) >= 0) {
                    _selected = adsMapping[i];
                    // _channel = i === "main" ? "index" : i
                    break;
                }
            }
            defaultParams["c"] = _selected;
            defaultParams["category"] = isTop ? "top" : channel;

            if (_selected >= 81 && _selected <= 88 && !isTop) {
                defaultParams["category"] = "tesezhuanqu";
            }
            if (isTop)
                delete defaultParams["channel"];

        }
        if (isyq) {
            defaultParams["c"] = 98;
        }
        if (isMobYq) {
            defaultParams["category"] = "youqingtuijian";
            delete defaultParams["c"]
        }
        return defaultParams
    }
    themeBtnCls = () => {
        return PROD_SITE === 3 ? "theme_orange" : PROD_SITE === 2 ? "theme_blue" : "theme_oringinal"
    }
    themeHeader = () => {
        return !this.isPC() ? PROD_SITE === 3 ? "header_orange" : PROD_SITE === 2 ? "header_blue" : "header_original" : ''
    }
    dot = (word) => {
        if (!word) return;
        return `${word.slice(0, 35)}...`
    }
    open = (url) => {
        return setTimeout(() => {
            return window.open(url, "_blank")
        });
    }
    kefuOpen = () => {
        let _url = this.formLogin(true);
        const val = u.getLocalData(ELocalKey._BASE)?.customer_service_url;
        if (val) {
            return this.open(val)
        }
        if (this.isLogin()) {
            let __data = localStorage.getItem(ELocalKey._USER);
            try {
                __data = JSON.parse(u.decrypt(__data))
            } catch {
                return this.open(_url)    
            }
            return this.open(__data?.custom_url || _url)
        }
        return this.open(_url)
    }
    tgOpen = () => {
        const val = u.getLocalData(ELocalKey._BASE)?.contact_telegram;
        if (val) {
            return window.open(val)
        }
        return;
    }
    debounce = (func, delay) => {
        let timerId;
        return function (...args) {
          if (timerId) clearTimeout(timerId);
          timerId = setTimeout(() => {
            func(...args);
          }, delay || 500);
        };
    };
    // 指定页面不展示广告
    hideAdsOnCertainPages = () => {
        const pagesToHide = ["tese"];
        const _r = window.location.href;
        return pagesToHide.some((x) => _r.indexOf(x) > 0);
    }
    getStringtifyVal = (data) => {
        try {
            data = JSON.parse(data);
            return data;
        } catch {
            return null;
        }
    }
    timeoutCb = (cb) => {
        let tme = setTimeout(() => {
            cb()
            clearTimeout(tme)
        }, 1000);
    }
    getQtknToken = () => '1|laravel_sanctum_aCOVd8HbhKtjtJsQHszjtUKe5QvopgYJoXmqGEO5d8008030'
    getCurrentTime = () => new Date().getTime();
    charToRandValue = (char) => {
        return String.fromCharCode(char.charCodeAt(0) + 5);
    }
    randValueToChar = (randomValue) => {
        return String.fromCharCode(randomValue.charCodeAt(0) - 5);
    }
    isIOS = () => {
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator.platform;
        const maxTouchPoints = window.navigator.maxTouchPoints;
      
        // Check for iOS user agent (iPhone, iPad, iPod) or Macintosh platform with touch support (iPadOS 13+)
        const isCheck =  (/iPad|iPhone|iPod/.test(userAgent) || 
        (platform === 'MacIntel' && maxTouchPoints > 1)) &&
        !window.MSStream;

        console.log('ios??' , isCheck);
        return isCheck; // Exclude Windows devices with iPad in userAgent
    }
}
const u = new Util();
export default u

export const ELocalKey = {
    _BASE: "_BASE",
    _CATER: "_CATER",
    _LOCK_CATER: "_LOCK_CATER",
    _CONF: "_CONF",
    _USER: "_USER",
    _BROWSE: "_BROWSER",
    _TESE: "_TESE",
    _FORMAT: "_FORMAT",
    _LOCK_FORMAT: "_LOCK_FORMAT",
    _MM: "_MM",
    _CACHE: "_CACHE",
    __MM: "__MM", // script元素加载的mm
    __QX: "__QX", // script元素加载的qixia
    __BXL: "__BXL", // script元素加载的boxlayer
    __QTKN: "__QTKN", // 2次开发的接口token
    __P_SECOND: "__P_SECOND", // 2次弹窗的时间
    __P_THIRD: "__P_THIRD", // 2次弹窗的时间
    _MK: "_MK", // 中秋节弹窗,
    _MKLOGIN: "_MKLOGIN", // 通过中秋节弹窗登录
    _BT: "_BT", // buy topic,
    _NOTICE: "_NOTICE",
    _CJ: "_CJ", // cache jump
    _MSGUNSEEN: "_MSGUNSEEN", // msg unseen_count
}

export const EVIPtype = {
    VIP: "VIP",
    BUY: "BUY",
}

export const ProjectInfo = {
    ID: 1
}

export const categoryConstant = [ { "id": 57, "name": "VIP 专区", "channel": "vip", "url": "/vip/index.html", "parent_id": 0, "icon": "/img/menu/home_icon_vip area.png", "jump_name": "vipzq", "data": [ { "id": 58, "name": "猫咪推荐", "channel": "vip", "url": "/vip/list-mmtj-1.html", "parent_id": 57, "icon": "/img/menu/vip/maomituijian.png", "jump_name": "mmtj" }, { "id": 59, "name": "原创国产", "channel": "vip", "url": "/vip/list-ycgc-1.html", "parent_id": 57, "icon": "/img/menu/vip/yuanchuanguochan.png", "jump_name": "ycgc" }, { "id": 62, "name": "制服淫穴", "channel": "vip", "url": "/vip/list-zfyx-1.html", "parent_id": 57, "icon": "/img/menu/vip/zhifuyinxue.png", "jump_name": "zfyx" }, { "id": 60, "name": "换脸AI区", "channel": "vip", "url": "/vip/list-hlaiq-1.html", "parent_id": 57, "icon": "/img/menu/vip/huanlianai.png", "jump_name": "hlaiq" }, { "id": 61, "name": "三级综艺", "channel": "vip", "url": "/vip/list-sjzy-1.html", "parent_id": 57, "icon": "/img/menu/vip/sanjizongyi.png", "jump_name": "sjzy" }, { "id": 63, "name": "次元动漫", "channel": "vip", "url": "/vip/list-cydm-1.html", "parent_id": 57, "icon": "/img/menu/vip/ciyuandongman.png", "jump_name": "cydm" }, { "id": 64, "name": "欧美大片", "channel": "vip", "url": "/vip/list-omdp-1.html", "parent_id": 57, "icon": "/img/menu/vip/oumei dapian.png", "jump_name": "omdp" }, { "id": 65, "name": "同性恋区", "channel": "vip", "url": "/vip/list-txzq-1.html", "parent_id": 57, "icon": "/img/tongxing.png", "jump_name": "txzq" } ] }, { "id": 149, "name": "VIP 专区2", "channel": "remen", "url": "/remen/index.html", "parent_id": 0, "icon": "", "jump_name": "vipzq2", "data": [ { "id": 150, "name": "新片速递", "channel": "remen", "url": "/remen/list-xpsd-1.html", "parent_id": 149, "icon": "", "jump_name": "xpsd" }, { "id": 151, "name": "独家精选", "channel": "remen", "url": "/remen/list-djjx-1.html", "parent_id": 149, "icon": "", "jump_name": "djjx" }, { "id": 152, "name": "国产传媒", "channel": "remen", "url": "/remen/list-gccm-1.html", "parent_id": 149, "icon": "", "jump_name": "gccm" }, { "id": 153, "name": "精品高清", "channel": "remen", "url": "/remen/list-jpgq-1.html", "parent_id": 149, "icon": "", "jump_name": "jpgq" }, { "id": 154, "name": "著名厂商", "channel": "remen", "url": "/remen/list-zmcs-1.html", "parent_id": 149, "icon": "", "jump_name": "zmcs" }, { "id": 155, "name": "探花大神", "channel": "remen", "url": "/remen/list-thss-1.html", "parent_id": 149, "icon": "", "jump_name": "thss" }, { "id": 156, "name": "私拍泄密", "channel": "remen", "url": "/remen/list-spxm-1.html", "parent_id": 149, "icon": "", "jump_name": "spxm" }, { "id": 157, "name": "AV解说", "channel": "remen", "url": "/remen/list-avjs-1.html", "parent_id": 149, "icon": "", "jump_name": "avjs" } ] }, { "id": 158, "name": "官方推荐", "channel": "remen2", "url": "/remen/index.html", "parent_id": 0, "icon": "", "jump_name": "zztj", "data": [ { "id": 167, "name": "反差少女", "channel": "remen2", "url": "/remen/list-fcsn-1.html", "parent_id": 158, "icon": "", "jump_name": "fcsn" }, { "id": 168, "name": "绳艺调教", "channel": "remen2", "url": "/remen/list-sytj-1.html", "parent_id": 158, "icon": "", "jump_name": "sytj" }, { "id": 169, "name": "觅圈正妹", "channel": "remen2", "url": "/remen/list-nqzm-1.html", "parent_id": 158, "icon": "", "jump_name": "nqzm" }, { "id": 170, "name": "裸播大秀", "channel": "remen2", "url": "/remen/list-lbdx-1.html", "parent_id": 158, "icon": "", "jump_name": "lbdx" }, { "id": 171, "name": "主播艳舞", "channel": "remen2", "url": "/remen/list-zbyw-1.html", "parent_id": 158, "icon": "", "jump_name": "zbyw" }, { "id": 172, "name": "私人订制", "channel": "remen2", "url": "/remen/list-srdz-1.html", "parent_id": 158, "icon": "", "jump_name": "srdz" }, { "id": 173, "name": "黑丝玉足", "channel": "remen2", "url": "/remen/list-hsyz-1.html", "parent_id": 158, "icon": "", "jump_name": "hsyz" }, { "id": 174, "name": "吃瓜黑料", "channel": "remen2", "url": "/remen/list-cghl-1.html", "parent_id": 158, "icon": "", "jump_name": "cghl" } ] }, { "id": 159, "name": "另类色情", "channel": "remen3", "url": "/remen/index.html", "parent_id": 0, "icon": "", "jump_name": "llsq", "data": [ { "id": 175, "name": "VR色情", "channel": "remen3", "url": "/remen/list-vrsq-1.html", "parent_id": 159, "icon": "", "jump_name": "vrsq" }, { "id": 176, "name": "巨乳嫩穴", "channel": "remen3", "url": "/remen/list-jlnx-1.html", "parent_id": 159, "icon": "", "jump_name": "jlnx" }, { "id": 177, "name": "男同拉拉", "channel": "remen3", "url": "/remen/list-ntll-1.html", "parent_id": 159, "icon": "", "jump_name": "ntll" }, { "id": 178, "name": "御宅伪娘", "channel": "remen3", "url": "/remen/list-yzwn-1.html", "parent_id": 159, "icon": "", "jump_name": "yzwn" }, { "id": 179, "name": "泄密外流", "channel": "remen3", "url": "/remen/list-xmwl-1.html", "parent_id": 159, "icon": "", "jump_name": "xmwl" }, { "id": 180, "name": "知名网黄", "channel": "remen3", "url": "/remen/list-zmwh-1.html", "parent_id": 159, "icon": "", "jump_name": "zmwh" }, { "id": 181, "name": "黑鬼淫妻", "channel": "remen3", "url": "/remen/list-hgyq-1.html", "parent_id": 159, "icon": "", "jump_name": "hgyq" }, { "id": 182, "name": "禁漫里番", "channel": "remen3", "url": "/remen/list-jmlf-1.html", "parent_id": 159, "icon": "", "jump_name": "jmlf" } ] }, { "id": 1, "name": "在线电影", "channel": "shipin", "url": "/shipin/index.html", "parent_id": 0, "icon": "/img/menu/home_icon_Movie.png", "jump_name": "zxdy", "data": [ { "id": 8, "name": "短视频区", "channel": "shipin", "url": "/shipin/list-dsp-1.html", "parent_id": 1, "icon": "/img/menu/shipin/duanshipinqu.png", "jump_name": "dsp" }, { "id": 9, "name": "美女主播", "channel": "shipin", "url": "/shipin/list-mnzb-1.html", "parent_id": 1, "icon": "/img/menu/shipin/meinvzhubo.png", "jump_name": "mnzb" }, { "id": 10, "name": "国产精品", "channel": "shipin", "url": "/shipin/list-gcjp-1.html", "parent_id": 1, "icon": "/img/menu/shipin/guochanjingpin.png", "jump_name": "gcjp" }, { "id": 11, "name": "中文字幕", "channel": "shipin", "url": "/shipin/list-zwzm-1.html", "parent_id": 1, "icon": "/img/menu/shipin/zhongwenzimu.png", "jump_name": "zwzm" }, { "id": 13, "name": "亚洲无码", "channel": "shipin", "url": "/shipin/list-yzwm-1.html", "parent_id": 1, "icon": "/img/menu/shipin/yazhouwuma.png", "jump_name": "yzwm" }, { "id": 14, "name": "欧美精品", "channel": "shipin", "url": "/shipin/list-omjp-1.html", "parent_id": 1, "icon": "/img/menu/shipin/oumeijingpin.png", "jump_name": "omjp" }, { "id": 15, "name": "精彩动漫", "channel": "shipin", "url": "/shipin/list-crdm-1.html", "parent_id": 1, "icon": "/img/menu/shipin/jingcaidongman.png", "jump_name": "crdm" }, { "id": 12, "name": "女优专区", "channel": "shipin", "url": "/shipin/list-nyzq-1.html", "parent_id": 1, "icon": "/img/menu/shipin/nvyouzhuanqu.png", "jump_name": "nyzq" } ] }, { "id": 140, "name": "手机下载", "channel": "cili", "url": "/cili/index.html", "parent_id": 0, "icon": "/img/menu/home_icon_app.png", "jump_name": "sjxz", "data": [ { "id": 141, "name": "国产原创", "channel": "cili", "url": "/cili/list-gcyc-1.html", "parent_id": 140, "icon": "/img/menu/xiazai/yazhoudianying.png", "jump_name": "gcyc" }, { "id": 142, "name": "岛国有码", "channel": "cili", "url": "/cili/list-dgym-1.html", "parent_id": 140, "icon": "/img/menu/xiazai/qiangjianluanlun.png", "jump_name": "dgym" }, { "id": 143, "name": "岛国无码", "channel": "cili", "url": "/cili/list-dgwm-1.html", "parent_id": 140, "icon": "/img/menu/xiazai/zhifusiwa.png", "jump_name": "dgwm" }, { "id": 144, "name": "西方美人", "channel": "cili", "url": "/cili/list-xfmr-1.html", "parent_id": 140, "icon": "/img/menu/xiazai/oumeidianying.png", "jump_name": "xfmr" }, { "id": 145, "name": "动漫精品", "channel": "cili", "url": "/cili/list-dmzq-1.html", "parent_id": 140, "icon": "/img/menu/xiazai/chengrendongman.png", "jump_name": "dmzq" }, { "id": 146, "name": "三级伦理", "channel": "cili", "url": "/cili/list-sjll-1.html", "parent_id": 140, "icon": "/img/menu/xiazai/biantailinglei.png", "jump_name": "sjll" }, { "id": 147, "name": "高清中文", "channel": "cili", "url": "/cili/list-gqzw-1.html", "parent_id": 140, "icon": "/img/menu/xiazai/jingdiansanji.png", "jump_name": "gqzw" }, { "id": 148, "name": "素人系列", "channel": "cili", "url": "/cili/list-srxl-1.html", "parent_id": 140, "icon": "/img/menu/xiazai/guochanzipai.png", "jump_name": "srxl" } ] }, { "id": 3, "name": "激情图区", "channel": "tupian", "url": "/tupian/index.html", "parent_id": 0, "icon": "/img/menu/home_icon_Photograph.png", "jump_name": "jqtq", "data": [ { "id": 25, "name": "自拍偷拍", "channel": "tupian", "url": "/tupian/list-zptp-1.html", "parent_id": 3, "icon": "/img/menu/tupian/toupaizipai.png", "jump_name": "zptp" }, { "id": 26, "name": "亚洲色图", "channel": "tupian", "url": "/tupian/list-yzst-1.html", "parent_id": 3, "icon": "/img/menu/tupian/yazhousetu.png", "jump_name": "yzst" }, { "id": 27, "name": "欧美色图", "channel": "tupian", "url": "/tupian/list-omst-1.html", "parent_id": 3, "icon": "/img/menu/tupian/oumeisetu.png", "jump_name": "omst" }, { "id": 28, "name": "美腿丝袜", "channel": "tupian", "url": "/tupian/list-mtsw-1.html", "parent_id": 3, "icon": "/img/menu/tupian/meituisiwa.png", "jump_name": "mtsw" }, { "id": 29, "name": "清纯唯美", "channel": "tupian", "url": "/tupian/list-qcwm-1.html", "parent_id": 3, "icon": "/img/menu/tupian/qingchunweimei.png", "jump_name": "qcwm" }, { "id": 30, "name": "乱伦熟女", "channel": "tupian", "url": "/tupian/list-llsn-1.html", "parent_id": 3, "icon": "/img/menu/tupian/luanlunshunv.png", "jump_name": "llsn" }, { "id": 31, "name": "卡通动漫", "channel": "tupian", "url": "/tupian/list-ktdm-1.html", "parent_id": 3, "icon": "/img/menu/tupian/katongmanhua.png", "jump_name": "ktdm" }, { "id": 32, "name": "极品美女", "channel": "tupian", "url": "/meinv/index.html", "parent_id": 3, "icon": "/img/menu/tupian/jipinmeinv.png", "jump_name": "jpmv" } ] }, { "id": 4, "name": "撸撸图区", "channel": "meinv", "url": "/meinv/index.html", "parent_id": 0, "icon": "/img/menu/home_icon_picture.png", "jump_name": "lltq", "data": [ { "id": 33, "name": "高清美女", "channel": "meinv", "url": "/meinv/index.html", "parent_id": 4, "icon": "/img/menu/meinv/gaoqingmeinv.png", "jump_name": "gqmn" }, { "id": 40, "name": "极品美女", "channel": "meinv", "url": "/meinv/index.html", "parent_id": 4, "icon": "/img/menu/meinv/jipinmeinv.png", "jump_name": "jpmv" }, { "id": 39, "name": "打飞机区", "channel": "meinv", "url": "/meinv/index.html", "parent_id": 4, "icon": "/img/menu/meinv/dafeijiqu.png", "jump_name": "dfjq" }, { "id": 38, "name": "撸管图片", "channel": "meinv", "url": "/meinv/index.html", "parent_id": 4, "icon": "/img/menu/meinv/luguantupian.png", "jump_name": "lgtp" }, { "id": 37, "name": "巨乳诱惑", "channel": "meinv", "url": "/meinv/index.html", "parent_id": 4, "icon": "/img/menu/meinv/juruyouhuo.png", "jump_name": "jryh" }, { "id": 36, "name": "极品诱惑", "channel": "meinv", "url": "/meinv/index.html", "parent_id": 4, "icon": "/img/menu/meinv/jipinyouhuo.png", "jump_name": "jpyh" }, { "id": 35, "name": "推女郎图", "channel": "meinv", "url": "/meinv/index.html", "parent_id": 4, "icon": "/img/menu/meinv/tuinvlangtu.png", "jump_name": "tnlt" }, { "id": 34, "name": "美女诱惑", "channel": "meinv", "url": "/meinv/index.html", "parent_id": 4, "icon": "/img/menu/meinv/meinvyouh.png", "jump_name": "mvyh" } ] }, { "id": 5, "name": "情色小说", "channel": "xiaoshuo", "url": "/xiaoshuo/index.html", "parent_id": 0, "icon": "/img/menu/home_icon_xiaoshuopng.png", "jump_name": "qsxs", "data": [ { "id": 41, "name": "都市激情", "channel": "xiaoshuo", "url": "/xiaoshuo/list-dsjq-1.html", "parent_id": 5, "icon": "/img/menu/xiaoshuo/dushijiq.png", "jump_name": "dsjq" }, { "id": 42, "name": "人妻交换", "channel": "xiaoshuo", "url": "/xiaoshuo/list-rqjh-1.html", "parent_id": 5, "icon": "/img/menu/xiaoshuo/renqijiaohuan.png", "jump_name": "rqjh" }, { "id": 43, "name": "校园春色", "channel": "xiaoshuo", "url": "/xiaoshuo/list-xycs-1.html", "parent_id": 5, "icon": "/img/menu/xiaoshuo/xiaoyuanchunse.png", "jump_name": "xycs" }, { "id": 44, "name": "家庭乱伦", "channel": "xiaoshuo", "url": "/xiaoshuo/list-jtll-1.html", "parent_id": 5, "icon": "/img/menu/xiaoshuo/jiatingluanlun.png", "jump_name": "jtll" }, { "id": 45, "name": "情色笑话", "channel": "xiaoshuo", "url": "/xiaoshuo/list-qsxh-1.html", "parent_id": 5, "icon": "/img/menu/xiaoshuo/qingsexiaohua.png", "jump_name": "qsxh" }, { "id": 46, "name": "性爱技巧", "channel": "xiaoshuo", "url": "/xiaoshuo/list-xajq-1.html", "parent_id": 5, "icon": "/img/menu/xiaoshuo/xingaijiqiao.png", "jump_name": "xajq" }, { "id": 47, "name": "武侠古典", "channel": "xiaoshuo", "url": "/xiaoshuo/list-wxgd-1.html", "parent_id": 5, "icon": "/img/menu/xiaoshuo/wuxiaogudian.png", "jump_name": "wxgd" }, { "id": 48, "name": "另类小说", "channel": "xiaoshuo", "url": "/xiaoshuo/list-llxs-1.html", "parent_id": 5, "icon": "/img/menu/xiaoshuo/lingleixiaoshuo.png", "jump_name": "llxs" } ] }, { "id": 6, "name": "有声小说", "channel": "yousheng", "url": "/yousheng/index.html", "parent_id": 0, "icon": "/img/menu/home_icon_youshengxiaospng.png", "jump_name": "ysxs", "data": [ { "id": 51, "name": "有声连载", "channel": "yousheng", "url": "https://xjhc3cf1bf43.top", "parent_id": 6, "icon": "/img/menu/yousheng/youshengxiaoshuo.png", "jump_name": "yslz" }, { "id": 52, "name": "色情小说", "channel": "yousheng", "url": "https://xjhc3cf1bf43.top", "parent_id": 6, "icon": "/img/menu/yousheng/seqingxiaoshuo.png", "jump_name": "sqxs" }, { "id": 54, "name": "少妇白洁", "channel": "yousheng", "url": "/yousheng/index.html", "parent_id": 6, "icon": "/img/menu/yousheng/shaofubaijie.png", "jump_name": "sfbj" }, { "id": 55, "name": "冰峰魔恋", "channel": "yousheng", "url": "/yousheng/index.html", "parent_id": 6, "icon": "/img/menu/yousheng/bingfengmolian.png", "jump_name": "bfml" }, { "id": 53, "name": "金鳞全集", "channel": "yousheng", "url": "/yousheng/index.html", "parent_id": 6, "icon": "/img/menu/yousheng/jinlinquanji.png", "jump_name": "jlqj" }, { "id": 56, "name": "天地之间", "channel": "yousheng", "url": "/yousheng/index.html", "parent_id": 6, "icon": "/img/menu/yousheng/tiandizhijian.png", "jump_name": "tdzj" }, { "id": 50, "name": "性爱录音", "channel": "yousheng", "url": "/yousheng/index.html", "parent_id": 6, "icon": "/img/menu/yousheng/xingailuyin.png", "jump_name": "xaly" }, { "id": 49, "name": "有声小说", "channel": "yousheng", "url": "/yousheng/index.html", "parent_id": 6, "icon": "/img/menu/yousheng/youshenglianzai.png", "jump_name": "ysxs" } ] }, { "id": 66, "name": "发现", "channel": "find", "url": "/news/index.html", "parent_id": 0, "icon": "/img/menu/", "jump_name": "发现", "data": [ { "id": 67, "name": "新闻", "channel": "news", "url": "/news/list-xw-1.html", "parent_id": 66, "icon": "/img/menu/news/", "jump_name": "xw" }, { "id": 68, "name": "福利", "channel": "news", "url": "/news/list-fl-1.html", "parent_id": 66, "icon": "/img/menu/news/", "jump_name": "fl" }, { "id": 69, "name": "APP推荐", "channel": "news", "url": "/app-down/index.html", "parent_id": 66, "icon": "/img/menu/news/", "jump_name": "APP推荐" }, { "id": 106, "name": "直播", "channel": "news", "url": "https://www.instv2135.com", "parent_id": 66, "icon": "https://cdn4.buysellads.net/uu/1/3386/1525189943-38523.png", "jump_name": "直播" } ] } ];
export const teseConstant = [{"name":"猫咪头条","url":"https://eadfvefx.xyz","provider_id":5,"img":null},{"name":"直播视频","url":"https://b2xvnwqonq1l1h.xyz/?code=laoban","provider_id":3,"img":null},{"name":"草榴社区","url":"https://cld29c.top","provider_id":9,"img":null},{"name":"麻豆系列","url":"https://tbfrae6n9k.xyz","provider_id":6,"img":null},{"name":"P站高清","url":"https://eosdp79dzj3yn5.xyz/?code=lb","provider_id":2,"img":null},{"name":"成人论坛","url":"https://8tzua4e3b2.xyz","provider_id":8,"img":null},{"name":"海角社区","url":"https://hjcb93.top","provider_id":4,"img":null},{"name":"你的G点","url":"https://g2d6i5an2.com","provider_id":0,"img":null}];